import * as React from 'react';
import {FunctionComponent} from 'react';
import {isSameWeek} from 'date-fns';
import createTheme from 'spectacle/lib/themes/default';
import {Deck, Heading, List, ListItem} from 'spectacle';
import {Slide} from './components/slide';
import {Global} from './model/global';
import {Financial} from './slides/financial';
import {Sprint} from './model/sprint';
import {ProjectsOverview} from './slides/projects/projects_overview';
import {Estimate} from './model/estimate';
import {ProjectDetail} from './slides/projects/project_detail';
import {IdeaWeekThisWeek} from './slides/idea_week_this_week';
import {IdeaWeekLastWeek} from './slides/idea_week_last_week';

require('normalize.css');

const theme = createTheme(
    {
        primary: 'white',
        secondary: '#1F2022',
        tertiary: '#9dadaf',
        fourth: '#F1F7F7',
    },
    {
        primary: 'BebasNeue,sans-serif',
        secondary: 'NHGDP,sans-serif',
    },
);

declare var GLOBAL: Global;

interface OwnProps {}

export const Presentation: FunctionComponent<OwnProps> = ({}) => {
    const data = GLOBAL;
    const now = new Date();

    const ideaWeekSprintNames = ['Idea week', 'Development week'];

    const sprintsThisWeek = data.sprints
        .filter((sprint) => !ideaWeekSprintNames.includes(sprint.estimate.name))
        .filter((sprint) => isSameWeek(now, new Date(sprint.date)))
        .sort((a, b) => a.estimate.name.localeCompare(b.estimate.name));

    const ideaWeekSprintsThisWeek = data.sprints
        .filter((sprint) => ideaWeekSprintNames.includes(sprint.estimate.name))
        .filter((sprint) => isSameWeek(now, new Date(sprint.date)))
        .sort((a, b) => a.estimate.name.localeCompare(b.estimate.name));

    const ideaWeekSprintsLastWeek = data.sprints
        .filter((sprint) => ideaWeekSprintNames.includes(sprint.estimate.name))
        .filter((sprint) => !isSameWeek(now, new Date(sprint.date)))
        .sort((a, b) => a.estimate.name.localeCompare(b.estimate.name));

    const estimatesWithSprints = data.sprints
        .filter((sprint) => !ideaWeekSprintNames.includes(sprint.estimate.name))
        .reduce((p: Array<EstimateWithSprints>, sprint: Sprint) => {
            const customerIdentifier =
                sprint.estimate.moneybird_contact_id === null
                    ? sprint.estimate.name
                    : '' + sprint.estimate.moneybird_contact_id;
            let find = p.find((item) => item.customer_identifier === customerIdentifier);
            if (find === undefined) {
                find = {
                    customer_identifier: customerIdentifier,
                    estimates: [],
                    sprintsThisWeek: [],
                    sprintsLastWeek: [],
                };
                p.push(find);
            }
            find.estimates.push(sprint.estimate);
            if (isSameWeek(now, new Date(sprint.date))) {
                find.sprintsThisWeek.push(sprint);
            } else {
                find.sprintsLastWeek.push(sprint);
            }

            return p;
        }, [])
        .sort((a, b) => a.estimates[0].owner.name.localeCompare(b.estimates[0].owner.name));

    return (
        <Deck transition={['zoom', 'slide']} transitionDuration={500} theme={theme}>
            <Slide major>
                <Heading size={1} textAlign="left" textColor="secondary">
                    Weekly Meeting
                </Heading>
                <List margin="30px 0 0" textFont="secondary" textColor="secondary" bold>
                    <ListItem>Financial update</ListItem>
                    <ListItem>Projects</ListItem>
                    <ListItem>Idea week</ListItem>
                    <ListItem>Acquisition</ListItem>
                    <ListItem>Other updates</ListItem>
                </List>
            </Slide>
            <Financial data={GLOBAL} />
            <ProjectsOverview sprints={sprintsThisWeek} />
            {estimatesWithSprints.map((estimateWithSprints) => (
                <ProjectDetail
                    key={estimateWithSprints.customer_identifier}
                    estimateWithSprints={estimateWithSprints}
                />
            ))}
            {...ideaWeekSprintsLastWeek.map((sprint) => {
                return <IdeaWeekLastWeek key={sprint.employee.name} sprint={sprint} />;
            })}
            {ideaWeekSprintsThisWeek.length > 0 && <IdeaWeekThisWeek sprints={ideaWeekSprintsThisWeek} />}
            <Slide major>
                <Heading size={1} textAlign="left" textColor="secondary">
                    Acquisition
                </Heading>
            </Slide>
            <Slide major>
                <Heading size={1} textAlign="left" textColor="secondary">
                    Other updates
                </Heading>
            </Slide>
            <Slide major>
                <img src={GLOBAL.giphy} />
            </Slide>
        </Deck>
    );
};

export interface EstimateWithSprints {
    customer_identifier: string;
    estimates: Estimate[];
    sprintsThisWeek: Sprint[];
    sprintsLastWeek: Sprint[];
}
